import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import debounce from 'lodash/debounce';
import { mapGetters, mapActions } from 'vuex';
import { FAST_TIMER } from '~/const/timers';
import registerStoreModule from '~/helpers/store-helper';
import configurator from '~/store/modules/configurator';
import TcVars from '~/components/functional/TcVars/ConfiguratorTcVars.vue';

const MdmLoader = () => import('~/components/atoms/Global/MdmLoader.vue');

const ConfiguratorSummary = () => import('~/components/organisms/Configurator/ConfiguratorSummary.vue');

const ConfiguratorControlPanel = () => import('~/components/organisms/Configurator/ConfiguratorControlPanel.vue');

const OpenGraph = () => import(
/* webpackChunkName: "product-sheet" */
'~/components/functional/OpenGraph/ProductOpenGraph.vue');

export default {
  layout: 'blank',
  components: {
    TcVars,
    MdmLoader,
    ConfiguratorSummary,
    ConfiguratorControlPanel,
    OpenGraph
  },

  data() {
    return {
      customizableWatcher: false
    };
  },

  validate(_ref) {
    let {
      params
    } = _ref;
    return params.model;
  },

  computed: _objectSpread({}, mapGetters({
    locale: 'i18n/locale',
    options: 'configurator/options',
    information: 'configurator/information',
    encodedCustomizable: 'configurator/encodedCustomizable',
    customizable: 'configurator/customizable',
    selectedOption: 'configurator/selectedOption',
    configurator: 'configurator/configurator',
    price: 'configurator/price',
    baseURL: 'request/baseURL'
  }), {
    openGraphImage() {
      return "https://medias.maisonsdumonde.com/q_auto/w_375,dpr_1.3/canape-so-me/".concat(this.$route.params.model, "-C-1.png");
    },

    currentPath() {
      return "".concat(this.baseURL).concat(this.$route.path);
    }

  }),

  created() {
    registerStoreModule(this.$store, 'configurator', configurator);

    if (process.client) {
      this.fetchConfigurator({
        model: this.$route.params.model
      });
    }
  },

  mounted() {
    this.customizableWatcher = this.$watch('encodedCustomizable', debounce((model, oldModel) => {
      if (oldModel) {
        const {
          params
        } = this.$route;
        window.history.replaceState('', '', "/".concat(params.market, "/").concat(params.language, "/configurator/").concat(model));
        this.fetchConfigurator({
          model
        });
      }
    }, FAST_TIMER));
  },

  destroyed() {
    this.customizableWatcher();
    this.$store.unregisterModule('configurator');
  },

  methods: _objectSpread({}, mapActions({
    fetchConfigurator: 'configurator/fetchConfigurator'
  })),

  head() {
    return {
      title: 'So…me | Maisons du Monde',
      meta: [{
        charset: 'utf-8'
      }, {
        name: 'robots',
        content: 'noindex, nofollow'
      }]
    };
  }

};